function r(r){for(var n=[];Array.isArray(r);)n.push(r.length),r=r[0];return n}export{r as arrayDims};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amap/amap-vue/es/utils/array.js
// module id = null
// module chunks = 